import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  TAgentChatbot,
  TCreateChatbotSettingsPayload,
} from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const useCreateChatBotSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: TCreateChatbotSettingsPayload) => {
      return HttpService.post<TAgentChatbot>({
        path: EServerPath.chatbotSettings,
        payload: params,
      })
    },
    onSuccess: (response, variables) => {
      queryClient.setQueryData(
        queryKeys.chatbotSettings(response?.data?.id || variables.agentId),
        response,
      )

      queryClient.invalidateQueries({
        queryKey: queryKeys.chatbotSettings(
          response?.data?.agentId || variables.agentId,
        ),
      })
    },
  })
}

export default useCreateChatBotSettings
